import script from "./CMD00011.vue?vue&type=script&setup=true&lang=ts"
export * from "./CMD00011.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__